@if (!withDialog) {
  <div class="relative" data-testid="search-box-container" [formGroup]="form">
    <div
      class="flex items-center p-4 gap-2 md:gap-2 rounded-full md:px-6 md:py-2 md:pr-[50px] md:h-12 header-search cursor-pointer"
      data-testid="search-box-input-container">
      <i class="pi pi-search text-lg" data-testid="search-box-icon"></i>
      <div class="absolute right-[20px] hidden md:block border-l border-gray pl-3">
        <a
          routerLink="/search"
          tooltipPosition="bottom"
          pTooltip="{{ 'Advanced search' | translate }}"
          ><i class="pi pi-sliders-v text-lg" data-testid="search-box-icon"></i
        ></a>
      </div>
      <p-autoComplete
        #autoCompleteRef
        formControlName="translations"
        [suggestions]="searchResults"
        placeholder="{{ 'Search' | translate }}"
        [dropdown]="false"
        [minLength]="1"
        [appendTo]="'body'"
        [styleClass]="'w-full'"
        [inputStyleClass]="
          'w-full !bg-transparent !border-0 !outline-none !shadow-none hidden md:block placeholder:text-xs lg:placeholder:text-base !px-2'
        "
        (completeMethod)="onSearch($event)"
        (onSelect)="onResultSelect($event)">
        <ng-template let-item pTemplate="item">
          <div class="flex items-center gap-2 w-full">
            <ng-container *ngIf="item?.image">
              <img class="rounded-lg size-10" [src]="item.image" [alt]="item.name" />
            </ng-container>

            <div class="flex flex-col">
              <div>{{ item.name }}</div>
              <div class="text-xs text-gray">{{ item.entity_type }}</div>
            </div>
          </div>
        </ng-template>

        <ng-template #footer *ngIf="searchResults?.length > 8">
          <a
            routerLink="/search"
            class="text-sm text-gray cursor-pointer px-4 py-3 border-t border-gray block hover:text-primary">
            {{ 'See more' | translate }} →
          </a>
        </ng-template>
      </p-autoComplete>
      <!--
      @if (this.form.value['translations']) {
        <span class="cursor-pointer p-1 mr-2 text-red-500 text-xs" (click)="resetForm()">
          <mat-icon class="text-red-300">delete</mat-icon></span
        >
      }
        -->
    </div>
  </div>
} @else {
  <div class="relative" data-testid="search-box-container">
    <div
      class="flex items-center p-4 gap-2 md:gap-2 rounded-full md:px-6 md:py-2 md:h-12 header-search cursor-pointer"
      data-testid="search-box-input-container"
      (click)="searchOpen()">
      <i class="pi pi-search text-lg" data-testid="search-box-icon"></i>
      <input
        pInputText
        type="text"
        class="w-full !bg-transparent !border-0 !outline-none !shadow-none hidden md:block placeholder:text-xs lg:placeholder:text-base"
        data-testid="search-box-input"
        placeholder="{{ 'What are you looking for' | translate }}?"
        (click)="searchOpen()" />
    </div>
  </div>
  @if (showDialog) {
    <p-dialog
      header="{{ 'General search' | translate }}"
      [modal]="true"
      [closeOnEscape]="true"
      [resizable]="true"
      [closable]="true"
      [dismissableMask]="true"
      [maximizable]="true"
      [style]="{ width: '35rem' }"
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
      [(visible)]="showDialog"
      (onHide)="closeDialog()">
      @if (showDialog) {
        <div class="flex flex-wrap searchdesign" [formGroup]="form">
          <div class="flex w-full items-center justify-between">
            <p-autoComplete
              formControlName="translations"
              class="flex-1"
              [suggestions]="searchResults"
              placeholder="{{ 'Type something to start the search' | translate }}"
              [dropdown]="false"
              [minLength]="3"
              [appendTo]="'body'"
              [styleClass]="'w-full'"
              [inputStyleClass]="'w-full'"
              (completeMethod)="onSearch($event)"
              (onSelect)="onResultSelect($event)">
              <ng-template let-item pTemplate="item">
                <div class="flex items-center">
                  @if (item.image) {
                    <img width="30" class="mr-2" [src]="item.image" [alt]="item.name" />
                  }
                  <span>{{ item.name }}</span>
                  <small class="ml-2 text-muted">({{ item.entity_type }})</small>
                </div>
              </ng-template>
            </p-autoComplete>
            @if (this.form.value['translations']) {
              <span class="cursor-pointer p-1 mr-2 text-red-500 text-xs" (click)="resetForm()">
                <mat-icon class="text-red-300">delete</mat-icon></span
              >
            }
          </div>
          <p-divider class="w-full" />
          <!-- @if (form.value['translations'] && recent_search_parameters?.keywords) {
      <div class="w-full">
        <h2 class="font-semibold text-xs text-blue-200 mb-2 mt-0 px-1">
          {{ 'Recent searches' | translate }}
        </h2>

        <ul class="list-none m-0 p-0">
          @for (recent_keyword of recent_search_parameters?.keywords; track recent_keyword.id) {
            <li
              class="select-none p-2 text-white-alpha-80 font-light leading-6 text-sm cursor-pointer rounded-lg hover:bg-white-alpha-20 hover:text-white"
              (click)="recentkeyword(recent_keyword?.label)">
              {{ recent_keyword?.label }}
            </li>
          }
        </ul>
      </div>
    } -->
          <div class="flex flex-wrap mb-3">
            @if (form.value['statusType'] === 'status_filtered') {
              <p-radioButton
                formControlName="statusType"
                [inputId]="'all'"
                [value]="'all'"
                (onClick)="setToAll()" />
              <label for="all" class="ml-2">{{ 'All' | translate }}</label>
            }
            @if (form.value['statusType'] === 'all') {
              <p-radioButton formControlName="statusType" [inputId]="'all'" [value]="'all'" />
              <label for="all" class="ml-2">{{ 'All' | translate }}</label>
            }
          </div>

          <div class="flex flex-wrap gap-3">
            @if (platform === 'core') {
              <div class="flex items-center gap-2 cursor-pointer">
                <p-toggleswitch
                  formControlName="is_businesses"
                  class="flex"
                  [inputId]="'is_businesses'" />
                <label for="is_businesses"> {{ 'Businesses' | translate }}</label>
              </div>

              <div class="flex items-center gap-2 cursor-pointer">
                <p-toggleswitch formControlName="is_apps" class="flex" [inputId]="'is_apps'" />
                <label for="is_apps"> {{ 'Applications' | translate }}</label>
              </div>
              <div class="flex items-center gap-2 cursor-pointer">
                <p-toggleswitch
                  formControlName="is_catalogs"
                  class="flex"
                  [inputId]="'is_catalogs'" />
                <label for="is_catalogs"> {{ 'Other' | translate }}</label>
              </div>

              <div class="flex items-center gap-2 cursor-pointer">
                <p-toggleswitch
                  formControlName="is_members"
                  class="flex"
                  [inputId]="'is_members'" />
                <label for="is_members"> {{ 'Members' | translate }}</label>
              </div>
            }
            <div class="flex items-center gap-2 cursor-pointer">
              <p-toggleswitch formControlName="is_ads" class="flex" [inputId]="'is_ads'" />
              <label for="is_ads"> {{ 'Ads' | translate }}</label>
            </div>
            @if (platform === 'erp') {
              <div class="flex items-center gap-2 cursor-pointer">
                <p-toggleswitch
                  formControlName="is_co_workers"
                  class="flex"
                  [inputId]="'is_co_workers'" />
                <label for="is_co_workers"> {{ 'Co workers' | translate }}</label>
              </div>
              <div class="flex items-center gap-2 cursor-pointer">
                <p-toggleswitch
                  formControlName="is_prospects"
                  class="flex"
                  [inputId]="'is_prospects'" />
                <label for="is_prospects"> {{ 'Prospects' | translate }}</label>
              </div>
            }
          </div>
        </div>
      }
    </p-dialog>
  }
}
